import { Controller } from "stimulus"
import consumer from '../../channels/consumer'
import CableReady from "cable_ready"

export default class extends Controller {
  initialize() {
    this.subscription()
  }

  disconnect() {
    this.subscription().unsubscribe()
    this.subscription().disconnected()
  }

  subscription() {
    //let room = 'company_' + this.element.dataset.room
    if (this._subscription == undefined) {
      let _this = this
      this._subscription = consumer.subscriptions.create('CompanyChannel', {
        connected() {
          console.log('Connected to Company channe')
        },
        disconnected() { },
        received(data) {
          console.log('DATA incomming on Company Channel')
          if (data.cableReady) CableReady.perform(data.operations)
        }
      })
    }
    return this._subscription
  }

}
